import { RestResource } from '../rest'
import {athubAxios} from "../../util/athub-axios";
import {AuthInfo} from '@/util/user/authInfo';

import { PERSON_SERVER } from '../server'

const user = new RestResource({server: PERSON_SERVER, resource: 'sysuser'});

user.getRoleUsers = async () => {
  return athubAxios.post(`${PERSON_SERVER}/roleuser/page`, {
    personid: localStorage.getItem('username'),
    orgid: AuthInfo.details.authorg,
  });
}


export default user;
